export default __webpack_public_path__ + "static/Logo-Travala-1e3a6a5d1a35b45502de3a8cc309130b.png";